import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/_layout/inventory/inbound-rental-agreements_/$id"
)({
  component: InboundRentalAgreementDetailRoute,
});

import { ProtectedRoute } from "@/components/protected-route";
import { InboundRentalAgreementDetailPage } from "@/components/inventory/InboundRentalAgreementDetailPage";

function InboundRentalAgreementDetailRoute() {
  const { id } = Route.useParams();
  // Same gate as the list page: InboundRentalAgreementViewSet's
  // read_permission ("inventory.stock.view") covers retrieve too.
  return (
    <ProtectedRoute requiredPermission="inventory.stock.view">
      <InboundRentalAgreementDetailPage agreementId={id} />
    </ProtectedRoute>
  );
}
